import { VColorPicker } from 'vuetify/lib/components/VColorPicker';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VColorPicker,{staticClass:"ma-2",attrs:{"mode":"rgba","hide-canvas":""},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})
}
var staticRenderFns = []

export { render, staticRenderFns }